import EmployeeList from "../../components/features/employees/EmployeeList";

const EmployeesPage = () => {
  return <EmployeeList />;
};

export default EmployeesPage;
